import { z } from 'zod';

export const TranslationDataSchema = z.record(z.string());

export const TranslationSchema = z.object({
  enabled: z.boolean(),
  data: TranslationDataSchema,
});